import { queryClient } from '@m43/core';
import type { EventPanelView, EventQueueWireDto } from '@mark43/cad-api';

/**
 * The modal opens before its event panel view is fetched, so the priority comes from the event's
 * queue row, or from an already cached panel view. With neither, the department's catch-all (NONE)
 * row applies.
 */
export function getIncomingAssignmentEventPriority(
    eventId: number,
    eventQueueView: EventQueueWireDto | undefined
): { priorityId: number | null | undefined; agencyTypeGlobalAttrId: number | null | undefined } {
    if (eventQueueView?.priorityId !== undefined && eventQueueView.priorityId !== null) {
        return {
            priorityId: eventQueueView.priorityId,
            agencyTypeGlobalAttrId: eventQueueView.agencyTypeGlobalAttrId,
        };
    }
    const eventPanelView = queryClient.getQueryData<EventPanelView>(['event-panel-view', eventId]);
    return {
        priorityId: eventPanelView?.form?.priority?.value,
        agencyTypeGlobalAttrId:
            eventPanelView?.metadata?.agencyTypeGlobalAttrId ??
            eventQueueView?.agencyTypeGlobalAttrId,
    };
}
